/**
 * Represents the request headers accepted by OCAPI.
 */
export var OcapiHeader;
(function (OcapiHeader) {
    /**
     * Determines the response data type, e.g. 'application/json'
     */
    OcapiHeader["Accept"] = "Accept";
    /**
     * The Global Authentication Service (GAS) token used for authentication.
     */
    OcapiHeader["Authorization"] = "Authorization";
    /**
     * Current Loyalty session token, represents a 'signed-in' member.
     *
     * TODO: Change to kebab-case when available. #296754
     */
    OcapiHeader["LoyaltyAuthorization"] = "loyaltySessionToken";
    /**
     * Identifies the region/territory of the user.
     */
    OcapiHeader["RegionCode"] = "Connect-Region-Code";
    /**
     * Identifies the Connect tenant of the user.
     */
    OcapiHeader["TenantId"] = "Vista-Tenant";
    /**
     * Used to correlate log entries in different Vista application log files to help identify the source of a request.
     *
     * TODO: Change to kebab-case when available. #296754
     */
    OcapiHeader["CorrelationId"] = "correlationId";
    /**
     * Represents a client-side captcha response.
     *
     * TODO: Change to kebab-case when available. #296754
     */
    OcapiHeader["CaptchaResponse"] = "CaptchaResponse";
})(OcapiHeader || (OcapiHeader = {}));
//# sourceMappingURL=ocapi-header.js.map